export default function SuperText({text, color}) {
    return text && (<sup style={{verticalAlign: 'middle', fontSize: 'xx-small', color: color}}>({text})</sup>)
}